/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from 'react';

import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Tag,
  Tooltip,
  message,
  Button,
  Avatar,
  Typography,
  Spin, 
  Space,
  Modal
} from "antd";



import {
  CheckCircleOutlined,
  CloudUploadOutlined,
  EyeOutlined,
  FundViewOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  LoadingOutlined,
  DeleteOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';

import MlView from "./../components/MlView";
import NewModel from "./../components/NewModel";


import {getMlLists,pushLiveModal,removeMlModal,timefix,_ENV} from './../services';

const { confirm } = Modal;



const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 60,
    }}
    spin
  />
);


// table code start





const data = [];


class MlModel extends React.Component {

      state ={
        usersList :[],
        currentUser:false,
        isLoader:true,
        userListState:[],
        columns:[],
        mlViewBox:false,
        mlViewBoxData:{},
      }

  async componentDidMount(){

      const columnsList = this.columnFetch();

      this.setState({
        columns: columnsList
      });

      this.syncData();

  }
  


  columnFetch = () =>{

    const columns = [
  //  {
  //   title: "#",
  //   key: "id",
  //   dataIndex: "id",
  //   render:(row,fsdf,index)=>{
  //     return (index+1);
  //   }
  // }, new Date('2023-01-22T06:17:30.631Z')
 {
    title: "Version",
    key: "live_sync",
    dataIndex: "live_sync",
    render:(index,record)=>{
      return (<span><Tag color={(record.live_sync || _ENV()=="PRODUCTION"  ? "green" :"orange")}><b><SafetyCertificateOutlined /> {(record.live_sync || _ENV()=="PRODUCTION"  ? "Live" : "Dev")}</b>
        </Tag>  <Tag color="blue"><b>{record.version}</b></Tag></span>);
    }
  },
  
  {
    title: "ID",
    key: "id",
    dataIndex: "id",
    render:(record)=>{
      return (<Tag color="blue"><b>{record}</b></Tag>);
    }
  },{
    title: "Created At",
    key: "created_at",
    dataIndex: "created_at",
    render:(record)=>{
      return (<Tag color="cyan"><b>{timefix(record)}</b></Tag>);
    }
  },
  {
    title: "W Version",
    key: "w_version",
    dataIndex: "w_version",
    render:(record)=>{
      return (<Tag color="purple"><b>{record}</b></Tag>);
    }
  },{
    title: "Activity Detection Version",
    key: "activity_detection_version",
    dataIndex: "activity_detection_version",
    render:(record)=>{
      return (<Tag color="yellow"><b>{record}</b></Tag>);
    }
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
    render:(index,record)=>{
      return (<div>
  {(_ENV()=="DEVELOPMENT" ? <Tooltip title="Push Model to Live environment">
      <Button onClick={()=>this.pushLiveModalEvent(record)}  className="live-model" type="primary" size="large" shape="circle" icon={<CloudUploadOutlined />} />
    </Tooltip> : " ")}
        <Tooltip title="View Model Details">
      <Button onClick={()=>this.viewLiveModalEvent(record)} className="view-model" type="primary" size="large" shape="circle" icon={<EyeOutlined />} />
    </Tooltip>
    
  
    

    <Tooltip title="Delete Model to this environment">
      <Button onClick={()=>this.removeModal(record)}  className="remove-model" type="primary" size="large" shape="circle" icon={<DeleteOutlined />} />
    </Tooltip> </div>);
    }
  }
];

    return columns;

  }

  viewLiveModalEvent = (content)=> {

    this.setState({
      mlViewBox:true,
      mlViewBoxData:content,
    });
  }

  closeLiveModalEvent =()=>{
     this.setState({
      mlViewBox:false,
      mlViewBoxData:{},
    });
  }

  removeModal = (content) => {
    console.log(content);
    const thisState = this;
    confirm({
      title:"Do you want to Delete this Model?",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        return new Promise(async (resolve, reject) => {

          const thisData = await removeMlModal(content);

          if (thisData.status === "success") {
            message.success(thisData.message);

            thisState.syncData();
            // window.location.reload();
            resolve(true);
          } else {
            message.error(thisData.message);
            reject(true);
          }

          // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        }).catch(() => console.log("Oops! Something went wrong"));
      },
      onCancel() {

      },
    });
  };

  pushLiveModalEvent = (content) => {
    const thisState = this;
    confirm({
      title:"Do you want to Push this Live?",
      icon: <span className="ok_pd_confirm"><CloudUploadOutlined /> </span>,
      onOk() {
        return new Promise(async (resolve, reject) => {



          const thisData = await pushLiveModal(content);

          if (thisData.status === "success") {
            message.success(thisData.message);

            thisState.syncData();
            // window.location.reload();
            resolve(true);
          } else {
            message.error(thisData.message);
            reject(true);
          }

          // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        }).catch(() => console.log("Oops! Something went wrong"));
      },
      onCancel() {

      },
    });
  };

  syncData = async() => {
   
   let thisMessage  = message;
    thisMessage.loading({
      content: 'Loading...',
      key:'ml_loader'
    });

     
    const {status,data} =  await getMlLists();

    // console.log(data);
   
    if(status=="success"){
       thisMessage.success({
        content: 'Loaded.',
        key:'ml_loader',
        duration: 2,
      });
  
      this.setState({
        usersList:data,
        isLoader:false
      });
    }
    
  };



  

 
  



  onChange = (e) => console.log(`radio checked:${e.target.value}`);
   render (){

    const {columns,usersList,currentUser,isLoader,mlViewBox,mlViewBoxData} = this.state;

   return(
    <>
      <div className="tabled ">

        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox ml_modal_table tablespace mb-24"
              title={<span>ML Model List <Tag color="gold">Total : {usersList.length}</Tag></span>}
              extra={
                <>
                 <NewModel   syncTrigger={()=>this.syncData()} />
                 <Button
        onClick={()=>this.syncData()}
        type="primary"
        style={{
          marginBottom: 16,
        }}
        icon={<SyncOutlined/>}
      >
        Sync 
      </Button> </>
              }
            >
         
            <Spin indicator={antIcon} spinning={isLoader} >
              <div className="table-responsive ml-model-page">
              <MlView visible={mlViewBox} onClose={()=>this.closeLiveModalEvent()} info={mlViewBoxData} />
                <Table
                  rowKey="id"
                  columns={columns}
                  dataSource={usersList}
                  pagination={true}
                  className="ant-border-space"
                />
              </div>
              </Spin>
            </Card>

            
          </Col>
        </Row>
      </div>
    </>
  );
    }
}

export default MlModel;
